import {useEffect} from "react";

// The consent manager locks scrolling while its panel is open by putting overflow: hidden on the
// body, and when the panel closes it sets overflow: auto there rather than putting the old value
// back. The host page sets html {overflow-y: scroll}, so the body's overflow is not handed on to the
// viewport and applies to the body itself, which is height: 100%. That means:
// - while the panel is open, the body clips the page to one screen, so opening Cookie Preferences
//   from the footer throws the page back to the top;
// - once it closes, the body becomes a second scroll container inside the page, with its own
//   scrollbar next to the page's, and window scroll events stop firing.
// cmp_disableoverflow is the manager's own switch to leave the body alone. It reads it every time
// the panel opens or closes, but may already have locked the body before the app loads, so undo that.
const useStopConsentScrollLock = () => {
    useEffect(() => {
        window.cmp_disableoverflow = true;
        document.body.style.removeProperty("overflow");
    }, []);
};

export default useStopConsentScrollLock;
